import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {SmartLabelPref} from '../constants';

export const smartLabelsImageEnabled = () =>
	getPreference(SmartLabelPref.IMAGE_ENABLED, true);
